<template>
  <div>
    Logging out...
  </div>
</template>

<script>
import auth from '../auth'
export default {
  name: 'Logout',
  created () {
    auth.logout()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
